import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChartTile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <rect width={29} height={2.5} x={2} y={18} fill="#E0E3E9" rx={1.25} />
    <path
      fill="#427FF8"
      d="M2 19.25c0-.69.56-1.25 1.25-1.25H20v2.5H3.25c-.69 0-1.25-.56-1.25-1.25"
    />
    <rect
      width={11.25}
      height={4.219}
      x={2.125}
      y={4}
      fill="#E0E3E9"
      rx={1.375}
    />
    <path
      fill="#949EB2"
      d="M16.367 5.21a.29.29 0 0 1 .484 0l.923 1.4a.29.29 0 0 1-.241.449h-1.848a.29.29 0 0 1-.241-.45l.923-1.4Z"
    />
  </svg>
);
export default SvgChartTile;
